export const fontSizes = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '28px',
  '4xl': '32px',
  '5xl': '40px',
  '6xl': '48px',
  '7xl': '56px',
};

export const fontWeights = {
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const lineHeights = {
  normal: 'normal',
  none: '1',
  xs: '1.125',
  sm: '1.25',
  md: '1.375',
  lg: '1.5',
  xl: '1.625',
  '2xl': '1.75',
  '3xl': '2',
  '4xl': '2.25',
  '5xl': '2.5',
};

export const letterSpacings = {
  normal: 'normal',
  xs: '0.5px',
  sm: '0.75px',
  md: '1px',
  lg: '1.25px',
  xl: '1.5px',
};
